import {useRouter} from "next/router";

const translate = {
  fr: [
    {
      value: 'fraud',
      label: 'Fraude',
    },
    {
      value: 'duplicate',
      label: 'Doublon',
    },
    {
      value: 'wrong-category',
      label: 'Mauvaise categorie',
    },
    {
      value: 'sold',
      label: 'Vendu',
    },
    {
      value: 'discrimination',
      label: 'Discrimination',
    },
    {
      value: 'other',
      label: 'Autre',
    },
  ],
  bi: [
    {
      value: 'fraud',
      label: 'Frod',
    },
    {
      value: 'duplicate',
      label: 'Kopi',
    },
    {
      value: 'wrong-category',
      label: 'rong kategori',
    },
    {
      value: 'sold',
      label: 'salem finis',
    },
    {
      value: 'discrimination',
      label: 'Diskriminesen',
    },
    {
      value: 'other',
      label: 'narawan',
    },
  ],
  en: [
    {
      value: 'fraud',
      label: 'Fraud',
    },
    {
      value: 'duplicate',
      label: 'Duplicate',
    },
    {
      value: 'wrong-category',
      label: 'Wrong category',
    },
    {
      value: 'sold',
      label: 'Sold',
    },
    {
      value: 'discrimination',
      label: 'Discrimination',
    },
    {
      value: 'other',
      label: 'Other',
    },
  ],
};

const reasons = () => {

  const { locale } = useRouter() ;

  return translate.hasOwnProperty(locale) ? translate[locale] : [];
}
export default reasons;
